import { createAxiosClient } from '@atlassian/temp-client-utils';
import { SourceSystem } from '@atlassian/cssxp-typescommon';

const bffClient = createAxiosClient({ baseURL: '/api/1' }, '');

interface FetchAvailableProductIdsForCloudSiteIds {
  cloudSiteIds: string[];
  transactionAccountId: string;
  isJiraOnTransferOperation?: boolean;
  fetchSandboxParentsData?: boolean;
}

// Ref. Doc https://hello.atlassian.net/wiki/spaces/~686306312/pages/3031564862/Epic+pager+-+Validation+of+new+product+addition+on+existing+cloud+site+URL
export const fetchAvailableProductIdsOnCloudSite = async (
  payload: FetchAvailableProductIdsForCloudSiteIds
): Promise<{
  existingProductIds: Record<string, string[]>;
  sandboxParentData: Record<string, Record<string, string>>;
}> => {
  const productIdResponse = await bffClient.post('/cloud-site/product-ids', payload);
  return productIdResponse.data;
};

interface FetchAvailableProductIdsByCloudSiteUrlParams {
  cloudSiteUrl: string;
  transactionAccountId: string;
  isJiraOnTransferOperation?: boolean;
  fetchSandboxParentsData?: boolean;
}

export const fetchAvailableProductIdsByCloudSiteUrl = async (
  payload: FetchAvailableProductIdsByCloudSiteUrlParams
): Promise<{
  cloudSiteId: string;
  existingProductIds: string[];
  applicableInvoiceGroupId: string | undefined;
  existingFamilyContainerId: string | undefined;
  sourceSystem: SourceSystem;
  isThereJiraProductsLinkedToADifferentTXA: boolean;
  sandboxParentData: Record<string, Record<string, string>>;
}> => {
  const productIdResponse = await bffClient.post('/cloud-site/product-ids-by-url', payload);
  return productIdResponse.data;
};
